import { Component, OnInit, ViewChild } from "@angular/core";
import { ITreeOptions, TreeNode, TreeModel } from "@circlon/angular-tree-component";
import * as moment from "moment";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars: any;

@Component({
	selector: "app-asset-management",
	templateUrl: "./asset-management.component.html",
	styleUrls: ["./asset-management.component.scss"]
})
export class AssetManagementComponent implements OnInit {
	@ViewChild("treeView") treeView: any;

	public brand = BrandVars;
	public treenodes: any[];
	public treeoptions: ITreeOptions = {
		allowDrag: (node: TreeNode) => {
			// return false;
			return node.id.startsWith("ast");
		},
		allowDrop: (element, { parent }) => {
			return parent.id && parent.id.startsWith && parent.id.startsWith("flt");
		},
		actionMapping: {
			mouse: {
				drop: async (tree: TreeModel, node: TreeNode, $event: any, { from, to }) => {
					let postscript = "";
					const params = { fleet_id: to.parent.data.fleet_id };
					if (to.parent.data.organization_id !== from.data.organization_id) {
						postscript = "\nThe asset config will also be reset, because it is owned by the previous organization.";
						params["organization_id"] = to.parent.data.organization_id;
					}
					if (confirm("Are you sure you want to move the asset " + from.data.asset_name + " to the fleet " + to.parent.data.fleet_name + "?\nThe OBCU will need to be updated." + postscript)) {
						await this.api.UpdateAssetAdmin(from.data.asset_id, params);
						await this.UpdateTree();
					}
				},
			},
		},
	};
	public selectedItem;

	public allAssets: any[];

	public newFleetName: string;
	public newAsset: any = {};
	public newAssetAuth: string;
	public selectedAsset: APIResults.Asset = undefined;

	public currentOrgId: number;
	public orgConfigs: APIResults.AssetConfig[] = [];

	constructor(public api: ApiService) { }

	ngOnInit() {
		this.UpdateTree();
	}

	public async UpdateTree() {
		const orgs = await this.api.GetFullTree();
		const allAssets = [];
		const now = moment();
		for (const org of orgs as TreeOrg[]) {
			org.id = "org" + org.organization_id;
			org.children = org.fleets;
			for (const fleet of org.fleets as TreeFleet[]) {
				fleet.id = "flt" + fleet.fleet_id;
				fleet.name = fleet.fleet_name;
				fleet.isExpanded = true;
				fleet.children = fleet.assets;
				for (const asset of fleet.assets as TreeAsset[]) {
					asset.id = "ast" + asset.asset_id;
					asset.name = asset.asset_name + " (" + asset.obcu_serial_number + ")";
					if (asset.last_login && asset.organization_id !== 1) {
						const darkDays = now.diff(moment(asset.last_login), "days");
						asset.late_days = darkDays;
						allAssets.push(asset);
					}
				}
			}
		}
		this.treenodes = orgs;
		this.allAssets = allAssets;
	}

	public async SelectAsset(target: APIResults.Asset) {
		if (this.treeView) {
			const assetNode = this.treeView.treeModel.getNodeById("ast" + target.asset_id);
			assetNode.setActiveAndVisible();
		}
	}

	public async ActivateNode(node: TreeNode) {
		this.selectedItem = node.data;
		node.expand();
		await this.ItemActivated();
	}

	private async ItemActivated() {
		this.selectedAsset = undefined;
		if (this.selectedItem.organization_id !== this.currentOrgId) {
			this.orgConfigs = [];
			this.currentOrgId = this.selectedItem.organization_id;
			this.orgConfigs = await this.api.GetAssetConfigs(this.currentOrgId);
		}
		if (this.selectedItem.id.startsWith("ast")) {
			this.selectedAsset = JSON.parse(JSON.stringify(this.selectedItem));
		}
	}

	public async AssetUpdated() {
		await this.UpdateTree();
	}

	public async UpdateFleet() {
		await this.api.ChangeOrgFleet(this.selectedItem.organization_id, this.selectedItem.fleet_id, this.selectedItem.time_offset_hours, this.selectedItem.hidden);
		await this.UpdateTree();
	}

	public async AddFleet() {
		if (!this.newFleetName) {
			throw new Error("Fleet name required");
		}
		await this.api.AddOrgFleet(this.selectedItem.organization_id, this.newFleetName);
		await this.UpdateTree();
		this.newFleetName = undefined;
	}

	public async DeleteFleet() {
		await this.api.DeleteFleet(this.selectedItem.organization_id, this.selectedItem.fleet_id);
		await this.UpdateTree();
		this.selectedItem = undefined;
	}

	public async AddAsset() {
		this.newAssetAuth = undefined;
		if (!(this.newAsset.asset_name && this.newAsset.obcu_serial_number)) {
			throw new Error("Asset name & OBCU serial required");
		}
		if (!BrandVars.localCloud) {
			const prefix = BrandVars.serialPrefix ? "FX" : "MX";
			const serialdata = {
				creator: this.api.user.email,
				environment: BrandVars.apiRoot,
				asset_type: prefix,
			};
			await this.api.SaveCoordinatorSerial(this.newAsset.obcu_serial_number, serialdata);
		}
		const result = await this.api.AddAsset(this.selectedItem.organization_id, this.selectedItem.fleet_id, this.newAsset.asset_type_id, this.newAsset.asset_name, this.newAsset.obcu_serial_number);
		await this.UpdateTree();
		this.newAssetAuth = result.auth;
	}


	public async FreshenSerial() {
		const fresh = await this.api.GetCoordinatorSerial(BrandVars.serialPrefix);
		this.newAsset.obcu_serial_number = fresh;
	}
}

interface TreeOrg extends APIResults.Organization {
	id: string;
	children: APIResults.Fleet[];
}
interface TreeFleet extends APIResults.Fleet {
	id: string;
	children: APIResults.Asset[];
	name: string;
	isExpanded: boolean;
}
interface TreeAsset extends APIResults.FleetAsset {
	id: string;
	name: string;
	late_days: number;
}